'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    &::before {\n      content: \'\';\n      position: absolute;\n      top: 0;\n      left: -22%;\n      background-color: ', ';\n      border-bottom-left-radius: 28%;\n      border-bottom-right-radius: 28%;\n      width: 144%;\n      height: 4%;\n    }\n  '], ['\n    position: relative;\n    &::before {\n      content: \'\';\n      position: absolute;\n      top: 0;\n      left: -22%;\n      background-color: ', ';\n      border-bottom-left-radius: 28%;\n      border-bottom-right-radius: 28%;\n      width: 144%;\n      height: 4%;\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      opacity: 0;\n    '], ['\n      opacity: 0;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    width: 80%;\n    margin-top: 30px;\n    margin-left: auto;\n    margin-right: auto;\n  '], ['\n    width: 80%;\n    margin-top: 30px;\n    margin-left: auto;\n    margin-right: auto;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    padding-left: 16px;\n    padding-right: 16px;\n  '], ['\n    padding-left: 16px;\n    padding-right: 16px;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    margin-top: -464px;\n  '], ['\n    margin-top: -464px;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRhumb = require('react-rhumb');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _CurrencyPicker = require('../common/CurrencyPicker');

var _CurrencyPicker2 = _interopRequireDefault(_CurrencyPicker);

var _GrowthSuiteTitle = require('./GrowthSuiteTitle');

var _GrowthSuiteTitle2 = _interopRequireDefault(_GrowthSuiteTitle);

var _GrowthSuiteTile = require('./GrowthSuiteTile');

var _GrowthSuiteTile2 = _interopRequireDefault(_GrowthSuiteTile);

var _Calculator = require('pricing-pages-unified-ui/components/calculator/Calculator');

var _Calculator2 = _interopRequireDefault(_Calculator);

var _SuiteCalcPriceDisplayTileContainer = require('pricing-pages-unified-ui/components/growth-suite-page/SuiteCalcPriceDisplayTileContainer');

var _SuiteCalcPriceDisplayTileContainer2 = _interopRequireDefault(_SuiteCalcPriceDisplayTileContainer);

var _SuiteCalcPlanSelectorTileContainer = require('pricing-pages-unified-ui/components/growth-suite-page/SuiteCalcPlanSelectorTileContainer');

var _SuiteCalcPlanSelectorTileContainer2 = _interopRequireDefault(_SuiteCalcPlanSelectorTileContainer);

var _colors = require('HubStyleTokens/colors');

var _Tracking = require('pricing-pages-unified-ui/constants/Tracking');

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _FooterMicrocopy = require('pricing-pages-unified-ui/components/common/FooterMicrocopy');

var _FooterMicrocopy2 = _interopRequireDefault(_FooterMicrocopy);

var _CustomerSupport = require('pricing-pages-unified-ui/static/js/components/common/CustomerSupport');

var _CustomerSupport2 = _interopRequireDefault(_CustomerSupport);

var _TabLayout = require('../TabLayout');

var _TabLayout2 = _interopRequireDefault(_TabLayout);

var _StyledBlob = require('../common/StyledBlob');

var _StyledBlob2 = _interopRequireDefault(_StyledBlob);

var _PageContainer = require('../common/PageContainer');

var _PageContainer2 = _interopRequireDefault(_PageContainer);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _DocumentUtils = require('pricing-pages-unified-ui/static/js/utils/DocumentUtils');

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _urls = require('pricing-pages-unified-ui/utils/urls');

var _Faq = require('pricing-pages-unified-ui/static/js/components/common/Faq');

var _Faq2 = _interopRequireDefault(_Faq);

var _Question = require('pricing-pages-unified-ui/static/js/components/common/Question');

var _Question2 = _interopRequireDefault(_Question);

var _PhoneSupport = require('pricing-pages-unified-ui/components/common/PhoneSupport');

var _PhoneSupport2 = _interopRequireDefault(_PhoneSupport);

var _PhoneSupportFooter = require('pricing-pages-unified-ui/components/common/PhoneSupportFooter');

var _PhoneSupportFooter2 = _interopRequireDefault(_PhoneSupportFooter);

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _reactRedux = require('react-redux');

var _FailedLoadBanner = require('pricing-pages-unified-ui/components/loading/FailedLoadBanner');

var _FailedLoadBanner2 = _interopRequireDefault(_FailedLoadBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PhoneSupportWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuitePage__PhoneSupportWrapper'
})(['width:450px;margin:40px auto;', ''], _responsiveBreakpoints2.default.phone(_templateObject));

var GrowthSuiteContainer = (0, _styledComponents2.default)(_PageContainer2.default).withConfig({
  displayName: 'GrowthSuitePage__GrowthSuiteContainer'
})(['', ' .growth-suite__blob{', '}'], _responsiveBreakpoints2.default.phone(_templateObject2, _colors.GYPSUM), _responsiveBreakpoints2.default.phone(_templateObject3));

var Blurb = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuitePage__Blurb'
})(['font-size:16px;width:590px;text-align:center;margin-bottom:60px;', ';', ';'], _responsiveBreakpoints2.default.tabletPortrait(_templateObject4), _responsiveBreakpoints2.default.phone(_templateObject));

var StyledPageContentContainer = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuitePage__StyledPageContentContainer'
})(['max-width:1280px;margin:0 auto;margin-top:-413px;padding:0 80px;', ';', ''], _responsiveBreakpoints2.default.cs(_templateObject5), _responsiveBreakpoints2.default.phone(_templateObject6));

var StyledUIFlex = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'GrowthSuitePage__StyledUIFlex'
})(['z-index:1;position:relative;']);

var GrowthSuitePage = function GrowthSuitePage(_ref) {
  var purchaseMotionRequestStatus = _ref.purchaseMotionRequestStatus;

  (0, _react.useEffect)(function () {
    (0, _getUsageTracker2.default)().track('pageView', {
      screen: _Tracking.SCREENS.GROWTH_SUITE
    });
  }, []);

  return _react2.default.createElement(
    _TabLayout2.default,
    { selectedPrimaryTab: 'growth-suite' },
    _react2.default.createElement(
      GrowthSuiteContainer,
      {
        className: 'growth-suite',
        'data-selenium-id': 'page-success'
      },
      purchaseMotionRequestStatus === _RequestStatusTypes2.default.SUCCEEDED && _react2.default.createElement(_reactRhumb.NavMarker, { name: 'GROWTH_SUITE_PAGE' }),
      _react2.default.createElement(_CurrencyPicker2.default, null),
      _react2.default.createElement(_StyledBlob2.default, { className: 'growth-suite__blob' }),
      _react2.default.createElement(
        StyledPageContentContainer,
        null,
        _react2.default.createElement(_FailedLoadBanner2.default, {
          hasFailed: purchaseMotionRequestStatus === _RequestStatusTypes2.default.FAILED
        }),
        _react2.default.createElement(
          StyledUIFlex,
          { justify: 'center', direction: 'column', align: 'center' },
          _react2.default.createElement(_GrowthSuiteTitle2.default, null),
          _react2.default.createElement(
            Blurb,
            null,
            _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.growthSuite.blurb' }),
            _react2.default.createElement(
              _UILink2.default,
              {
                className: 'm-left-1',
                external: true,
                href: (0, _urls.getSuiteLegalDisclaimerUrl)()
              },
              _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.growthSuite.details' })
            )
          ),
          _react2.default.createElement(_GrowthSuiteTile2.default, { edition: 'starter' }),
          _react2.default.createElement(_GrowthSuiteTile2.default, { edition: 'professional' }),
          _react2.default.createElement(_GrowthSuiteTile2.default, { edition: 'enterprise' })
        ),
        _react2.default.createElement(
          PhoneSupportWrapper,
          null,
          _react2.default.createElement(_PhoneSupport2.default, {
            phoneSourceId: 'growthsuite-middle',
            screen: _Tracking.SCREENS.GROWTH_SUITE
          })
        ),
        _react2.default.createElement(_Calculator2.default, {
          PlanSelectorComponent: _SuiteCalcPlanSelectorTileContainer2.default,
          PriceDisplayComponent: _SuiteCalcPriceDisplayTileContainer2.default
        }),
        _react2.default.createElement(_CustomerSupport2.default, null),
        _react2.default.createElement(
          _Faq2.default,
          null,
          _react2.default.createElement(_Question2.default, { questionKey: 'growthSuite.whatIsIt' }),
          _react2.default.createElement(_Question2.default, { questionKey: 'growthSuite.whatIsAUser' }),
          _react2.default.createElement(_Question2.default, { questionKey: 'growthSuite.upfrontPayment' }),
          _react2.default.createElement(_Question2.default, {
            questionKey: 'growthSuite.support',
            href: (0, _urls.getCommunityUrl)()
          }),
          _react2.default.createElement(_Question2.default, { questionKey: 'growthSuite.crmIntegration' }),
          _react2.default.createElement(_Question2.default, { questionKey: 'growthSuite.emailIntegration' }),
          _react2.default.createElement(_Question2.default, { questionKey: 'growthSuite.overageFees' }),
          _react2.default.createElement(_Question2.default, { questionKey: 'growthSuite.onboarding' }),
          _react2.default.createElement(_Question2.default, { questionKey: 'growthSuite.sendingFees' }),
          _react2.default.createElement(_Question2.default, {
            questionKey: 'growthSuite.limits',
            href: (0, _urls.getProductsAndServicesCatalogUrl)('#TechnicalLimits')
          }),
          _react2.default.createElement(_FooterMicrocopy2.default, null)
        ),
        _react2.default.createElement(_PhoneSupportFooter2.default, {
          phoneSourceId: 'growthsuite-footer',
          screen: _Tracking.SCREENS.GROWTH_SUITE
        })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    purchaseMotionRequestStatus: state.purchaseMotionRequestStatus
  };
};

exports.default = (0, _DocumentUtils.withDocumentTitle)((0, _reactRedux.connect)(mapStateToProps)(GrowthSuitePage), 'growthSuite');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/GrowthSuitePage.js
// module id = 770
// module chunks = 3 4